var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"wrap-dec"},[_c('b-col',{staticClass:"left",attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"box"}),_c('p',[_vm._v(_vm._s(_vm.name))])]),_c('b-col',{staticClass:"right",attrs:{"cols":"12","md":"6"}},[_c('p',[_c('span',[_vm._v(":")]),_vm._v(" "+_vm._s(_vm.data))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }